"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCreators = exports.InitialState = void 0;
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const connected_react_router_1 = require("connected-react-router");
const redux_1 = require("redux");
const redux_saga_1 = __importDefault(require("redux-saga"));
const history_1 = __importDefault(require("@/helpers/history"));
const sagas_1 = __importDefault(require("@/sagas"));
const api_1 = require("./api");
const habit_1 = require("./habit");
const payment_1 = require("./payment");
const user_1 = require("./user");
// Strange higher-order function to potentially modify the result
const logAction = (store) => (next) => (action) => {
    // @ts-ignore
    const before = store.getState();
    const result = next(action);
    if (process.env.NODE_ENV !== 'production') {
        // Group these console logs into one closed group
        /* eslint-disable no-console */
        // @ts-ignore
        const after = store.getState();
        console.groupCollapsed(`dispatching action => ${action.type}`);
        console.log('BEFORE', before);
        console.log('ACTION', action.type, action);
        console.log('AFTER', after);
        console.groupEnd();
        /* eslint-enable no-console */
    }
    return result;
};
const reducers = (0, redux_1.combineReducers)({
    api: (0, radio_dispatch_1.createApiReducer)(api_1.INITIAL_STATE),
    router: (0, connected_react_router_1.connectRouter)(history_1.default),
    user: user_1.reducer,
    payment: payment_1.reducer,
    habit: habit_1.reducer
});
exports.InitialState = {
    api: api_1.INITIAL_STATE,
    user: user_1.INITIAL_STATE,
    payment: payment_1.INITIAL_STATE,
    habit: habit_1.INITIAL_STATE,
};
exports.ActionCreators = {
    api: radio_dispatch_1.reduxSet,
    user: user_1.reduxSet,
    payment: payment_1.reduxSet,
    habit: habit_1.reduxSet,
};
const configureStore = (initialState = exports.InitialState) => {
    const sagaMiddleware = (0, redux_saga_1.default)();
    const middlewares = [sagaMiddleware, logAction, (0, connected_react_router_1.routerMiddleware)(history_1.default)];
    // @ts-ignore
    let middleware = (0, redux_1.applyMiddleware)(...middlewares);
    if (process.env.NODE_ENV !== 'production') {
        const { __REDUX_DEVTOOLS_EXTENSION__ } = window;
        if (typeof __REDUX_DEVTOOLS_EXTENSION__ === 'function') {
            middleware = (0, redux_1.compose)(middleware, __REDUX_DEVTOOLS_EXTENSION__());
        }
    }
    const store = (0, redux_1.createStore)(reducers, initialState, middleware);
    sagaMiddleware.run(sagas_1.default);
    return store;
};
exports.default = configureStore;
